export default "__VITE_ASSET__ab656f3c__"